import { apiGet } from "../../utils/api";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/pt-br";

const News = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/news");

      setNews((await payload).data.data);
    }
    exibir();
  }, []);

  const onChangeHandler = async (e) => {
    const payload = apiGet("/news/api/pesquisar?termo=" + e.target.value);
    setNews((await payload).data.data);
  };

  return (
    <div>
      <section id="producoes" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Notícias</h2>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <div className="search">
              <input
                type="text"
                onChange={(e) => onChangeHandler(e)}
                placeholder="Pesquise aqui..."
              />
            </div>
          </div>
        </div>
        <br />

        <div className="row mx-5 posts">
          {news && news.length
            ? news.map((newww) => {
                return (
                  <div
                    className="card mb-3"
                    // style="max-width: 1253px;"
                    key={newww.news_id}
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="card-body">
                          <h5 className="card-title">
                            <a
                              className="link2"
                              href={'readmore/"' + newww.title + '"'}
                            >
                              {newww.title}
                            </a>
                          </h5>
                          <p className="card-text m-0">
                            <small className="text-muted">
                              {moment(newww.date).format("LL")}
                            </small>
                          </p>

                          <p className="card-text m-0">
                            {newww.description.length > 500 ? (
                              <>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: newww.description
                                      .replaceAll("<p>", "")
                                      .replaceAll("</p>", "")
                                      .substr(0, 500),
                                  }}
                                ></span>
                                <span> ...</span>
                              </>
                            ) : (
                              <>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: newww.description
                                      .replaceAll("<p>", "")
                                      .replaceAll("</p>", ""),
                                  }}
                                ></span>
                              </>
                            )}
                          </p>

                          <div>
                            <a
                              className="link link--dia"
                              href={'readmore/"' + newww.title + '"'}
                            >
                              Leia mais...
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </section>
    </div>
  );
};

export default News;
